import { h } from "preact";
import { useState, useEffect, useMemo } from "preact/hooks";
import TimerContext from "./TimerContext";
import useInterval from "../../transcript/customHooks/useInterval";
import getRoundedNum from "../../transcript/helpers/getRoundedNum";
import { RATE, MILLISECOND } from "./globalVars";

type providerProps = {
  children?: h.JSX.Element | h.JSX.Element[] | string | string[];
  playing?: boolean;
  playbackRate: number;
  seekTime: number | undefined;
};

function TimerProvider(props: providerProps) {
  const [activeTimeInMilliseconds, setActiveTimeInMilliseconds] =
    useState<number>(0);
  const { playing, playbackRate, seekTime } = props;
  const delay = useMemo(() => RATE / playbackRate, [playbackRate]);

  useEffect(() => {
    if (seekTime) {
      setActiveTimeInMilliseconds(getRoundedNum(seekTime * MILLISECOND));
    }
  }, [seekTime]);

  useInterval(
    () => {
      if (activeTimeInMilliseconds >= 0) {
        setActiveTimeInMilliseconds(activeTimeInMilliseconds + RATE);
      }
    },
    // Delay in milliseconds or null to stop it
    playing ? delay : null
  );

  return (
    <TimerContext.Provider
      value={{ activeTimeInMilliseconds, setActiveTimeInMilliseconds }}
    >
      {props.children}
    </TimerContext.Provider>
  );
}

export default TimerProvider;
